import { useState, useEffect, useRef } from 'react'
import { MapContainer, TileLayer, Polyline, Tooltip, CircleMarker } from 'react-leaflet'
import route from 'attachments/route.json'

import getRegion from 'fn/getRegion'

import {
  GiRadioactive
} from 'react-icons/gi'

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip as RTooltip,
  Legend,
  CartesianGrid
} from 'recharts'

const CustomTooltip = ( {
  payload,
  label,
  active
} ) => {
  if ( active && payload && payload.length ) {
    return <div
      className="tooltip-table"
    >
      <ul>
        <li>
          <strong>ele</strong>
          <label>{ payload[ 0 ].value } m</label>
        </li>

        <li>
          <strong>km</strong>
          <label>{ payload[ 0 ].payload.distance } km</label>
        </li>
      </ul>
    </div>
  }
}

const Map = () => {
  const center = [ 19.320772, -99.151468 ]
  const [ points, setPoints ] = useState()
  const [ point, setPoint ] = useState()
  const [ lower, setLower ] = useState()
  const [ r, setR ] = useState()
  const map = useRef()

  useEffect( () => {
    if ( points ) return

    setPoints( points => {
      const aux = route
        .map( p => ( [ p.lat, p.lon ] ) )

      return aux
    } )
  } )

  useEffect( () => {
    if ( ! points || points.length === 0 )
      return

    const region = getRegion( points )
    map.current.fitBounds( region )

    // lower bound
    const eles = route.map( p => p.ele )
    const low = Math.min( ...eles )

    setLower( low )
  }, [ points ] )

  const pinIt = ( state ) => {
    if ( ! state || ! state.activeIndex )
      return

    const index = state.activeIndex
    const value = route[ index ]

    setPoint( point => {
      return value
    } )
 }

  return <div className="one hs">

    <div className="bar">
      <div className="icon">
        <GiRadioactive />
      </div>

      <h1>detalle</h1>
    </div>

    <div className="one hs gap-2x">
      <MapContainer
        ref={ map }
        className="one"
        center={ center }
        zoom={ 16 }
        scrollWheelZoom={ true }
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />

        { points ? <Polyline
          positions={ points }
          pathOptions={ {
            color: '#00fc1e'
          } }
        /> : null }

        { point ? <CircleMarker
          center={ [ point.lat, point.lon ] }
          radius={ 7 }
          pathOptions={ { color: '#00fc1e', fill: true } }
        >

          <Tooltip
            direction="auto"
            offset={[14, 0]}
            opacity={1}
            permanent
            className="map-tooltip"
          >

            <div className="hs">

              <div className="vs ai-center gap">
                <strong>ele</strong>

                <label>
                  { point.ele } m
                </label>
              </div>

              <div className="vs ai-center gap">
                <strong>km</strong>

                <label>
                  { point.distance } km
                </label>
              </div>

            </div>

          </Tooltip>

        </CircleMarker> : null }

      </MapContainer>
    </div>

    <div>
      <AreaChart
        style={ {
          width: '100%',
          aspectRatio: 1.618,
          maxHeight: 140
        } }
        data={ route }
        responsive
        onMouseMove={ pinIt }
      >
        <Area
          type="monotone"
          dataKey="ele"
          stroke="#00fc1e"
          strokeWidth={ 2 }
          fill="#116329"
          name="ele"
        />

        <YAxis
          width="auto"
          domain={ [ lower, 'auto' ] }
          label={{ value: 'elevación', position: 'insideLeft', angle: -90, dy: 45 }}
        />

        <XAxis
          dataKey="distance"
          domain={ [ 0, 'auto' ] }
          height={ 50 }
          label={ {
            value: 'km',
            position: 'insideBottom'
          } }
          allowDecimals={ false }
        />

        <RTooltip
          content={ <CustomTooltip /> }
        />
      </AreaChart>
    </div>

  </div>
}

export default Map

